import { render, staticRenderFns } from "./ModalBoardReportInformationCreator.vue?vue&type=template&id=2843e676&"
import script from "./ModalBoardReportInformationCreator.vue?vue&type=script&lang=js&"
export * from "./ModalBoardReportInformationCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports